import styled from 'styled-components'
import breakpoints from 'utils/consts/breakpoints'
import Country from 'components/Pages/Wine/View/Main/Content/ProductSpecs/Country'
import GeoIndication from 'components/Pages/Wine/View/Main/Content/ProductSpecs/GeoIndication'
import Grapes from 'components/Pages/Wine/View/Main/Content/ProductSpecs/Grapes'
import ChemicalAnalisys from 'components/Pages/Wine/View/Main/Content/ProductSpecs/ChemicalAnalisys'
import ClosureType from 'components/Pages/Wine/View/Main/Content/ProductSpecs/ClosureType'
import WineTypeEU from 'components/Pages/Wine/View/Main/Content/ProductSpecs/WineTypeEU'
import Ingredients from 'components/Pages/Wine/View/Main/Content/ProductSpecs/Ingredients'
import Vintages from '../Vintages'
import Package from '../Package'

const Wrapper = styled.div`
  grid-area: product-specs;
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  @media screen and ${breakpoints.device.tablet} {
    max-width: calc(100vw - 48px);
    margin-bottom: 24px;
  }

  @media screen and ${breakpoints.device.mobile} {
    max-width: calc(100vw - 32px);
    margin-bottom: 24px;
  }
`

const ProductSpecs = () => {
  return (
    <Wrapper>
      <Vintages />
      <Package />
      <Country />
      <GeoIndication />
      <WineTypeEU />
      <Grapes />
      <Ingredients />
      <ChemicalAnalisys />
      <ClosureType />
    </Wrapper>
  )
}

export default ProductSpecs
